import PageContent from "../../components/layout/PageContent";
import PageHeader from "../../components/layout/PageHeader";
import {useEffect, useState} from "react";
import Page from "../../models/api/Page";
import {Task} from "../../api/task/Task";
import {TaskAPI} from "../../api/task/TaskAPI";
import {showNotification} from "@mantine/notifications";
import {DataTable, DataTableColumn} from "mantine-datatable";
import DateTimeView from "../../components/date/DateTimeView";
import CreateTaskDialog from "./CreateTaskDialog";
import {Button} from "@mantine/core";
import {IconEye, IconTrash} from "@tabler/icons-react";
import {useContextMenu} from "mantine-contextmenu";
import {openConfirmModal} from "@mantine/modals";
import TaskPreview from "./TaskPreview";

const columns: DataTableColumn<Task>[] = [
    {
        accessor: 'title',
        title: 'Tytuł zadania'
    },

    {
        accessor: 'finishedAt',
        title: 'Czas zakończenia',
        render: ({finishedAt}) => <DateTimeView dateTime={finishedAt}/>
    },

    {
        accessor: 'assignedTo',
        title: 'Przypisanie',
        render: ({assignedTo}) => <>{ assignedTo && assignedTo.username }</>
    },

    {
        accessor: 'finishedBy',
        title: 'Zakończone przez',
        render: ({finishedBy}) => <>{ finishedBy && finishedBy.username }</>
    }
]

function TaskPage() {
    const [isFetching, setFetching] = useState(false);
    const [page, setPage] = useState<Page<Task>>();
    const [preview, setPreview] = useState<Task>();
    const [create, setCreate] = useState(false);
    const { showContextMenu } = useContextMenu();

    const onReloadError = () => {
        showNotification({
            title: 'Nie udało się pobrać danych',
            message: 'Spróbuj ponownie później',
            color: 'red'
        })
    }

    const reload = () => {
        setFetching(true);

        TaskAPI.getList({ page: 0, limit: 20 })
            .then(setPage)
            .catch(onReloadError)
            .finally(() => setFetching(false));
    }

    const onDeleteError = () => {
        showNotification({
            title: 'Nie udało się usunąć zadania',
            message: 'Spróbuj ponownie później',
            color: 'red'
        });
    }

    const onDeleteSuccess = () => {
        showNotification({
            title: 'Usunięto',
            message: '',
        });
    }

    const doDeleteTask = (task: Task) => {
        TaskAPI.deleteById(task.id)
            .then(reload)
            .then(onDeleteSuccess)
            .catch(onDeleteError)
            .finally(() => setFetching(false));
    }

    const deleteTask = (task: Task) => {
        openConfirmModal({
            title: "Usuwanie zadania",
            children: `Czy na pewno chcesz usunąć zadanie "${task.title}".`,
            labels: { confirm: `Tak`, cancel: 'Anuluj' },
            confirmProps: {color: 'red'},
            centered: true,
            onConfirm: () => doDeleteTask(task)
        })
    }

    useEffect(reload, []);

    return (
        <>
            <PageHeader
                title="Zadania"
                pageTitle="Zadania"
                url="/task"
                action={
                    <>
                        <CreateTaskDialog
                            opened={create}
                            onClose={() => { setCreate(false); reload(); }}
                        />

                        <Button onClick={() => setCreate(true)}>
                            Utwórz
                        </Button>
                    </>
                }
            />

            <PageContent>
                <DataTable
                    striped
                    highlightOnHover
                    mt="xl"
                    height="60vh"
                    withColumnBorders
                    styles={{ header: { background: 'white' } }}
                    backgroundColor={'transparent'}
                    fetching={isFetching}
                    minHeight={150}
                    noRecordsText={"Pusto..."}
                    loaderBackgroundBlur={1}
                    records={page?.content ?? []}
                    style={{marginBottom: '50px'}}
                    columns={columns}
                    onRowContextMenu={(data) => {
                        showContextMenu([
                            {
                              title: 'Podgląd',
                              icon: <IconEye size={16}/>,
                              key: 'preview-task',
                              onClick: () => setPreview(data.record),
                            },
                            {
                                title: 'Usuń',
                                icon: <IconTrash size={16}/>,
                                key: 'delete-ctx-menu-item(users)',
                                onClick: () => deleteTask(data.record),
                                color: 'red'
                            }
                        ])(data.event)
                        }
                    }
                />
            </PageContent>

            <TaskPreview
                isOpen={preview !== undefined}
                onClose={() => { setPreview(undefined); }}
                task={preview}
            />
        </>

    )
}

export default TaskPage;